import { SellingStatus } from "@/api/article";
import { Badge, BadgeProps } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

export interface SellingStatusBadgeProps {
  status: SellingStatus;
}

const statusToBadgeProps = (
  status: SellingStatus,
): { badge: Partial<BadgeProps>; text: string } => {
  switch (status) {
    case "SOLD":
      return { badge: { variant: "success" }, text: "badgeVendu" };
    case "UNSOLD":
      return { badge: { variant: "default" }, text: "badgeEnVente" };
  }
};

export const SellingStatusBadge = ({ status }: SellingStatusBadgeProps) => {
  const { badge, text } = statusToBadgeProps(status);

  const { t } = useTranslation();

  return <Badge {...badge}>{t(text)}</Badge>;
};
